import { useEffect, Fragment } from "react";
import { useSignal } from "@preact/signals-react";
import { FormattedMessage as FM } from "react-intl";

import proxy from "api/proxy";
import tools from "tools/dates";
import { useStore } from "storev2/formStore";
import { layout as layoutServiceLine } from "./model/layoutServiceLine";
import TableTitle from "componentsv2/table/TableTitle";
import BasicTable from "componentsv2/table/BasicTable";
import { useTable } from "storev2/tableStore";
import DishBreakfast from "./assets/DishBreakfast.png";
import DishLunch from "./assets/DishLunch.png";
import DishDinner from "./assets/DishDinner.png";

const today = tools.dateToday();
const Service_date = new Date()
  .toLocaleDateString("es-CO", {
    weekday: "long",
    day: "2-digit",
    month: "short",
    year: "numeric",
  })
  .replace(/de/g, " ");

const SERVICE_IMAGES = {
  breakfast: DishBreakfast,
  lunch: DishLunch,
  dinner: DishDinner,
};
const categories = ["breakfast", "lunch", "dinner"];

function ServiceHotel() {
  const recId = useSignal(null);
  const _serviceHotel = useSignal({
    breakfast: [],
    lunch: [],
    dinner: [],
  });
  const _serviceCard = useSignal({});
  const refreshTrigger = useSignal(0);

  const showTable = useSignal(null);
  const layout = layoutServiceLine();
  const { newRecord } = useStore();
  const { setTable } = useTable();
  const handleDataChange = () => {
    refreshTrigger.value += 1;
  };

  const attrsService = {
    name: "service",
    layout: layout,
    currentRecordId: useSignal(null),
  };

  async function initRecord() {
    const id = await newRecord(layout);
    recId.value = id;

    for (const category of categories) {
      const domainCard = [
        ["service_date", "=", today],
        ["kind.category", "=", category],
        ["state", "=", "open"],
      ];

      const fieldsCard = ["number", "service_date", "state", "kind"];

      const { data: serviceCard } = await proxy.search(
        "hotel.service",
        domainCard,
        fieldsCard,
      );

      _serviceCard.value[category] = serviceCard[0];

      const domain = [
        ["service.service_date", "=", today],
        ["service.kind.category", "=", category],
        ["service.state", "=", "open"],
      ];

      const fields = ["room.name", "guest", "quantity", "state"];

      const { data: service } = await proxy.search(
        "hotel.service.line",
        domain,
        fields,
      );
      _serviceHotel.value[category] = service;
      setTable({
        layout: layout,
        records: service,
        storeId: id,
        domain: false,
      });
    }
  }

  useEffect(() => {
    initRecord();
  }, [showTable.value, refreshTrigger.value]);

  return (
    <div className="w-full space-y-6 p-4">
      <div className="flex justify-between w-full items-center">
        <TableTitle layout={layout} />
        <div className="px-6 font-bold text-2xl">
          <span>{Service_date}</span>
        </div>
      </div>

      <div className="grid  2xl:grid-cols-3 grid-cols-2 gap-4">
        {categories.map((category) => {
          const services = _serviceHotel.value[category];
          const card = _serviceCard.value[category];

          if (!card) return null;

          const totalServices = services.length;

          const draftServices = services.filter(
            (item) => item.state === "draft",
          ).length;

          return (
            <Fragment key={category}>
              <div>
                <button
                  type="button"
                  onClick={() =>
                    (showTable.value =
                      showTable.value === category ? null : category)
                  }
                  className={`border border-gray-200 shadow-xl/30 rounded-2xl w-full h-40 pb-4 mb-6 cursor-pointer ${showTable.value === category ? "bg-blue-200 text-gray-50" : "bg-gray-100 hover:bg-gradient-to-t from-gray-100 to-[#EAEAEA]"}`}
                >
                  <div>
                    <h2 className="text-2xl font-bold text-center py-2 text-gray-900">
                      <FM id={category} />
                    </h2>
                  </div>

                  <div className="md:grid md:grid-cols-2">
                    <div className="flex flex-col items-center justify-center ">
                      <div className="hidden md:block w-full h-24 overflow-hidden rounded-t-2xl">
                        <img
                          src={SERVICE_IMAGES[category]}
                          alt={category}
                          className="w-full h-full object-contain  "
                        />
                      </div>
                    </div>

                    <div className="flex flex-col justify-start border-l border-neutral-900 space-y-4">
                      <div
                        className={`flex flex-row justify-start space-x-5 text-2xl font-normal text-center border-b-2 border-[#2FB0FF] mx-3 w-1/3 transition-colors duration-300 ${showTable.value === category ? "text-blue-900" : "text-neutral-900"}`}
                      >
                        <div className="pr-3">
                          <FM id="hotel.service.total" />
                        </div>
                        <span className="font-bold">{totalServices}</span>
                      </div>

                      <div
                        className={`flex flex-row justify-start space-x-5 text-2xl font-normal text-center items-center border-b-2 border-red-300 mx-3 w-1/2 transition-colors duration-300 ${showTable.value === category ? "text-red-900" : "text-neutral-900"}`}
                      >
                        <div>
                          <FM id="hotel.service.draft" />
                        </div>
                        <span className="font-bold">{draftServices}</span>
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            </Fragment>
          );
        })}
      </div>

      {recId.value && showTable.value && (
        <div className="w-full">
          <BasicTable
            {...attrsService}
            records={_serviceHotel.value[showTable.value]}
            recordStoreId={recId}
            storeId={recId.value}
            triggerUpdate={handleDataChange}
            closeModal={async (mustReload) => {
              if (mustReload) handleDataChange();
            }}
          />
        </div>
      )}
    </div>
  );
}

export default ServiceHotel;
